import React, { FC } from 'react';

type TZestLogoProps = {
  className?: string;
};

/**
 * Zest wordmark (ZEST-738). Vector from Figma, consolidated into one viewBox;
 * uses `currentColor` so it inherits the surrounding text colour (navy
 * `#1A3A5C` in the auth flow). Original design size: 90 × 28.29.
 */
const ZestLogo: FC<TZestLogoProps> = ({ className }) => (
  <svg
    className={className}
    width="90"
    height="28"
    viewBox="0 0 90.4 28.29"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-label="Zest"
  >
    <path
      transform="translate(0, 0.33)"
      d="M16.0097 6.0295H4.13654L4.99497 0H29.1382L13.4773 20.9287H25.785L24.771 27.4554H0L16.0097 6.0295Z"
      fill="currentColor"
    />
    <path
      transform="translate(27.73, 0.33)"
      d="M17.0237 21.3465L16.0472 27.4501H0L4.39944 0H20.4466L19.4326 6.33627H10.8323L10.1294 10.8267H18.1128L17.1793 16.7768H9.15297L8.41258 21.3465H17.0237Z"
      fill="currentColor"
    />
    <path
      transform="translate(46.38, 0)"
      d="M27.5126 6.02421L23.9984 27.8944H31.3326L34.8468 6.02421H42.5887L43.6188 0.132226L13.6436 0C7.83314 0 3.86292 3.80281 3.86292 9.07598C3.86292 12.4663 5.88559 14.1217 9.48025 15.9676C11.8892 17.2105 13.3002 17.8135 13.3002 19.3949C13.3002 20.7912 12.1897 21.8067 10.2797 21.8067C7.95118 21.8067 5.9607 20.6378 3.78244 18.3424L0 23.7266C2.55918 26.7414 5.76756 28.2858 9.43733 28.2858C16.5837 28.2858 20.7471 24.4036 20.7471 18.7549C20.7471 15.2536 19.1429 13.4447 15.6287 11.5248C13.1822 10.1708 11.3098 9.64191 11.3098 8.17156C11.3098 6.96566 12.3774 5.98719 13.9065 5.98719C14.3411 5.98719 27.5126 6.02421 27.5126 6.02421Z"
      fill="currentColor"
    />
  </svg>
);

export default ZestLogo;
